import ipxRuntime_36R4YIMotuw1WQcTlbvXlGmr2JIi5ZALuSwJf4DmrmrTg from '/app/node_modules/.pnpm/@nuxt+image@2.1.0_@types+node@25.5.0_magic-string@0.30.21_magicast@0.5.2_rolldown@1.2.3_unplu_jh6shcdavvnmjc6vqa4uowqnv4/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"ipx"} */
  provider: "ipx",
  providers: {
      ['ipx']: { setup: ipxRuntime_36R4YIMotuw1WQcTlbvXlGmr2JIi5ZALuSwJf4DmrmrTg, defaults: {} }
  }
}
